import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { AccessToken, AuthCredentialsResponse } from '../../../shared/models/auth-token.model';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {

  private readonly config = {
    storageAccessTokenName: 'SSID',
    storageRefreshTokenName: 'SSIDR',
  };

  storeCredentials = (authCredentials: AuthCredentialsResponse) => {
    localStorage.setItem(this.config.storageAccessTokenName, `Bearer ${authCredentials.accessToken}`);
    localStorage.setItem(this.config.storageRefreshTokenName, authCredentials.refreshToken);
  };

  getTokenData(): AccessToken {
    const token = localStorage.getItem(this.config.storageAccessTokenName);
    if (token) {
      const a = this.decodeToken<AccessToken>(token);
      return a;
    } else {
      this.stopSession();
      return null;
    }
  }

  getFirstName(): string {
    return this.getTokenData().given_name;
  }

  getLastName(): string {
    return this.getTokenData().family_name;
  }

  getUserId(): string {
    return this.getTokenData().sub;
  }

  getUserEmail(): string {
    return this.getTokenData().email;
  }

  getAccessToken(): string {
    return localStorage.getItem(this.config.storageAccessTokenName);
  }

  getRefreshToken(): string {
    return localStorage.getItem(this.config.storageRefreshTokenName);
  }

  checkAuth(): boolean {
    const token = localStorage.getItem(this.config.storageAccessTokenName);
    if (token && this.getTokenData()) {
      return true;
    } else {
      this.stopSession();
      return false;
    }
  }

  decodeToken<T>(token: string): T {
    return jwtDecode(token);
  }

  public stopSession(): void {
    localStorage.removeItem(this.config.storageAccessTokenName);
    localStorage.removeItem(this.config.storageRefreshTokenName);
  };
}
